import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-system-gray-300 h-[6px] overflow-hidden rounded-[100px]',
    line: 'transition-width before:bg-brand-400 relative rounded-[100px] duration-500 before:block before:h-[6px] before:rounded-[100px]'
  }
});
